import React from 'react';
import { TeamStats } from 'src/sections/team/new-team';

function TeamStatsPage() {
    return <TeamStats />;
}

export default TeamStatsPage;